module.exports = __webpack_public_path__ + "static/media/img_2.05cb20a1.png";